/**
 * OrbDocIndexSLOrbDocIndexSLPage
 *
 * Page component for OrbDocIndexSLOrbDocIndexSLPage
 * Path: /sl/docs
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocIndexSLDocScreenView as __OrbDocIndexSLDocScreenView } from '@/components/traits/OrbDocIndexSLDocScreenView';
import { OrbDocIndexSLDocAnalyticsView as __OrbDocIndexSLDocAnalyticsView } from '@/components/traits/OrbDocIndexSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocIndexSLOrbDocIndexSLPageProps {
  // Add any page-level props here
}

export function OrbDocIndexSLOrbDocIndexSLPage(_props: OrbDocIndexSLOrbDocIndexSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Dokumentacija Orb","description":"Spoznaj jezik, sestavljaj standardno knjižnico in poišči vsak operator in vsako vedenje.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs"},{"locale":"ar","path":"/ar/docs"},{"locale":"sl","path":"/sl/docs"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocIndexSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocIndexSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocIndexSLOrbDocIndexSLPage;
